export const CUSTOM_SLIDESHOW_CONTROLS_WRAPPER_LEFT_OFFSET = 5;
export const CUSTOM_SLIDESHOW_CONTROLS_WRAPPER_TOP_OFFSET = 15;
